// Copyright (c) 2020 Deere & Company

import './favorite-icon.scss';
import React, {PropTypes} from 'react';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const isActiveFavorite = (favorites, favorite) => favorites.some(item => item.id === favorite.id);

const mapStateToProps = (state, ownProps) => ({
    favorite: ownProps,
    isActiveFavorite: isActiveFavorite(state.app.favorites, ownProps)
});

const mapActionsToProps = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export const FavoriteIcon = props =>
    <span
        className={`${props.isActiveFavorite ? 'favorite-active' : 'favorite-inactive'}`}
        onClick={() => props.isActiveFavorite ? props.actions.deleteFavorite(props.favorite.id) : props.actions.addFavorites(props.favorite)}
    ></span>;

FavoriteIcon.displayName = 'FavoriteIcon';
FavoriteIcon.propTypes = {
    actions: PropTypes.object.isRequired,
    favorite: PropTypes.object.isRequired,
    isActiveFavorite: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, actionCreators, mapActionsToProps)(FavoriteIcon);




// WEBPACK FOOTER //
// ./src/shared/components/favorites/favorite-icon.js